import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useBaseAutocompleteOnChange } from '../../../../../../shared/components/base-autocomplete/hooks/use-base-autocomplete-on-change.hook';
import { castTo } from '../../../../../shared/utils/cast-to';
import { optionEquality } from '../../../../../shared/utils/option-equality/option-equality.util';
import { useGetBrands } from '../../../../hooks/use-get-brands/use-get-brands.hook';
import { FirmwareFilters } from '../../../../models/firmware-filters.model';
import {
  filterFirmwaresByBrand,
  resetBrandFilter,
} from '../../../../store/slices/firmware.slice';
import { mapBrandModelToItemLabelModel } from '../../../../utils/mapping/mapping.util';
import { FirmwareFilterProps } from '../../types/firmware-filter-props.type';
import { withFirmwareFilterValues } from '../with-firmware-filters-values/with-firmware-filters-values';

const BrandsDropdown: FunctionComponent<FirmwareFilterProps> = (
  props: PropsWithChildren<FirmwareFilterProps>
): ReactElement => {
  const brands = useGetBrands();
  const {
    setFieldValue,
    firmwareSelectFilters: { brandId },
  } = props;

  const onChange = useBaseAutocompleteOnChange<FirmwareFilters>(
    'brandId',
    filterFirmwaresByBrand,
    setFieldValue,
    [
      { fieldName: 'modelIds', valueToReset: [] },
      { fieldName: 'ecuIds', valueToReset: [] },
    ],
    resetBrandFilter
  );

  const brandOptions = brands.map(mapBrandModelToItemLabelModel);

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="firmware-brands"
      variant="filled"
    >
      <BaseAutocomplete
        disableClearable={false}
        freeSolo={false}
        id="brandId"
        isOptionEqualToValue={optionEquality}
        multiple={false}
        options={brandOptions}
        onChange={onChange}
        value={
          brandId
            ? brandOptions.find(x => x.id === castTo<number>(brandId))
            : null
        }
        renderInput={params => (
          <BaseRenderInput
            {...params}
            errors={props.errors}
            id="brandId"
            label="Brand"
            name="brandId"
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFirmwareFilterValues(BrandsDropdown);
